/* eslint-disable no-unsafe-optional-chaining */
import React, { useCallback } from "react";
import "./OrdersTab.scss";

// image imports
import OrderCalenderIcon from "assets/images/Shopping_basket.svg";
import DownloadIcon from "assets/images/download-icon.svg";
import { fetchRequest } from "utils/restApiCleintAxios";
import { useTypedSelector } from "store";
import { format } from "date-fns";
import OrdersMobileTab from "./OrdersMobileTab";
import { showMobile } from "helpers/adaptation";

interface Props {
  data?: any[];
}

function OrdersTab({ data }: Props) {
  const { ctoken } = useTypedSelector((store) => store.user.client);

  const onDownload = useCallback(
    async (val: any) => {
      try {
        const res = await fetchRequest("api/user/DownloadReceipt", {
          method: "post",
          data: {
            ctoken: ctoken,
            orderId: val?.orderId
          }
        });
        if (res.data?.url) {
          open(res.data?.url);
        }
      } catch (err) {
        console.error("err", err);
      }
    },
    [ctoken]
  );

  return (
    <>
      {showMobile && <OrdersMobileTab data={data} onDownload={onDownload} />}
      {!showMobile && (
        <div className="OrdersTab-main">
          <div className="OrdersTab-heading-icon">
            <div className="OrdersTab-icon-otr">
              <img className="OrdersTab-icon" src={OrderCalenderIcon} alt="icon" />
            </div>
            <h3 className="OrdersTab-heading">פרטי הזמנות</h3>
          </div>
          <table className="OrdersTable-main">
            <thead>
              <th>
                <div className="headtext-otr">
                  <p className="head-text">מספר הזמנה</p>
                </div>
              </th>
              <th>
                <div className="headtext-otr">
                  <p className="head-text">תאריך</p>
                </div>
              </th>
              <th>
                <div className="headtext-otr">
                  <p className="head-text">סכום</p>
                </div>
              </th>
              <th>
                <div className="headtext-otr">
                  <p className="head-text">מסלול</p>
                </div>
              </th>
              <th>
                <div className="headtext-otr">
                  <p className="head-text">קבלה</p>
                </div>
              </th>
            </thead>
            <tbody>
              {data?.map((val: any, index) => {
                return (
                  <tr key={`${index}${val?.orderId}`}>
                    <td>
                      <div className="bodytext-otr">
                        <p className="body-text">{val?.orderId}</p>
                      </div>
                    </td>
                    <td>
                      <div className="bodytext-otr">
                        <p className="body-text">
                          {format(new Date(val?.orderDate), "dd/LL/yyyy")}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="bodytext-otr">
                        <p className="body-text">₪{val?.sum}</p>
                      </div>
                    </td>
                    <td>
                      <div className="bodytext-otr">
                        <p className="body-text">{val?.productTitle}</p>
                      </div>
                    </td>
                    <td onClick={() => onDownload(val)}>
                      <span className="download-icon-otr" style={{ cursor: "pointer" }}>
                        <img className="download-icon" src={DownloadIcon} alt="icon" />
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default OrdersTab;
